module.exports = __webpack_public_path__ + "static/media/admin.92030fac.svg";